/**
 * Meta Purchase:
 * - Permitido en landings normales (bodys, basicas, hombres/BOPO, etc.).
 * - Bloqueado en storefront.
 * - Bloqueado en landings RM / remarketing (__czBlockMetaPurchase desde theme.liquid
 *   o pack pay-x-get-y).
 * El thank-you de Shopify checkout nativo sigue a cargo del canal Meta.
 */
(function (global) {
  function isLandingContext() {
    try {
      if (global.__czAllowMetaPurchase === true) {
        return true;
      }
      if (document.documentElement && document.documentElement.dataset.czLanding === "true") {
        return true;
      }
      if (global.sessionStorage && global.sessionStorage.getItem("cz_landing_draft_checkout") === "1") {
        return true;
      }
    } catch (error) {
      /* ignore */
    }
    return false;
  }

  function shouldAllowPurchase() {
    try {
      if (global.__czBlockMetaPurchase === true) {
        return false;
      }
      if (
        document.documentElement &&
        document.documentElement.dataset.czBlockMetaPurchase === "true"
      ) {
        return false;
      }
    } catch (error) {
      /* ignore */
    }
    return isLandingContext();
  }

  function isPurchaseEvent(command, args) {
    var cmd = String(command || "").toLowerCase();
    if (cmd === "track" || cmd === "trackcustom") {
      return String(args[1] || "").toLowerCase() === "purchase";
    }
    if (cmd === "tracksingle" || cmd === "tracksinglecustom") {
      return String(args[2] || "").toLowerCase() === "purchase";
    }
    return false;
  }

  function wrapFbq(original) {
    if (!original || original.__czPurchaseGuarded) {
      return original;
    }

    function guarded() {
      var args = Array.prototype.slice.call(arguments);
      if (isPurchaseEvent(args[0], args) && !shouldAllowPurchase()) {
        return;
      }
      return original.apply(this, args);
    }

    Object.keys(original).forEach(function (key) {
      try {
        guarded[key] = original[key];
      } catch (error) {
        /* ignore */
      }
    });
    guarded.queue = original.queue;
    guarded.callMethod = original.callMethod;
    guarded.push = original.push;
    guarded.loaded = original.loaded;
    guarded.version = original.version;
    guarded.__czPurchaseGuarded = true;
    return guarded;
  }

  function install() {
    if (typeof global.fbq === "function") {
      global.fbq = wrapFbq(global.fbq);
      if (global._fbq) {
        global._fbq = global.fbq;
      }
    }

    try {
      var descriptor = Object.getOwnPropertyDescriptor(global, "fbq");
      if (!descriptor || descriptor.configurable) {
        var current = global.fbq;
        Object.defineProperty(global, "fbq", {
          configurable: true,
          enumerable: true,
          get: function () {
            return current;
          },
          set: function (value) {
            current = wrapFbq(value);
          }
        });
        if (current) {
          current = wrapFbq(current);
        }
      }
    } catch (error) {
      /* ignore */
    }
  }

  install();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install);
  } else {
    install();
  }
  setTimeout(install, 0);
  setTimeout(install, 1500);
})(window);
